import { render, staticRenderFns } from "./contacts-container.vue?vue&type=template&id=9c70d5b6&scoped=true&"
import script from "./contacts-container.vue?vue&type=script&lang=js&"
export * from "./contacts-container.vue?vue&type=script&lang=js&"
import style0 from "./contacts-container.vue?vue&type=style&index=0&id=9c70d5b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c70d5b6",
  null
  
)

export default component.exports